<template>
	<div class="dashboard-heading card" :class="width">
		<h2>
			{{title}}
			<template v-if="small">
				<br>
				<small class="text-muted">{{small}}</small>
			</template>
		</h2>

		<slot></slot>
	</div>
</template>
<script type="text/javascript">
import Widget from "./Widget"

export default {
	name: "HeadingWidget",
	components: {
		Widget
	},
	props: ["title","small","width"]

}
</script>

<style type="text/css" scoped>
	.dashboard-heading {
		margin: auto;
		padding: 10px;
		background-color: white;
		box-shadow: 0 3px 1px -2px gray;
		margin-bottom: 10px;
	}

	.dashboard-heading h2 {
		margin-bottom: 0;
	}

	.dashboard-heading.lg {
		max-width: 1200px;
	}

	.dashboard-heading.md {
		max-width: 1000px;
	}

	.dashboard-heading.sm {
		max-width: 800px;
	}

	.dashboard-heading.xsm {
		max-width: 600px;
	}
</style>